// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".program-detail__content h1,.program-detail__content h2,.program-detail__content h3,.program-detail__content h4,.program-detail__content h5,.program-detail__content h6{font-family:\"Proxima Nova Heavy\"}.program-detail__description-text ul{list-style-type:disc;padding-left:1.5rem;padding-top:.5rem}.program-detail__description-text ul li{line-height:1.25rem}", ""]);
// Exports
module.exports = exports;
